module.exports = __webpack_public_path__ + "img/choose.png";